module.exports = __webpack_public_path__ + "static/media/icon-asisa-blue.58481472.svg";